import { CommonModule } from "@angular/common";
import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import { AffiliatesService } from "@app/affiliates/affiliates.service";
import { ComboboxComponent } from "@app/shared/components/combobox/combobox.component";
import { ScrollBlockerDirective } from "@app/shared/directives/scroll-blocker.directive";
import { SharedModule } from "@app/shared/shared.module";
import { configGeneral } from "src/app/affiliates/models/enum";
import { PromoList } from "src/app/affiliates/models/model";
import { PromoListsService } from "src/app/affiliates/services/promoList.service";
import { TrainingService } from "src/app/affiliates/services/training.service";

@Component({
  selector: "general-modal",
  imports: [CommonModule, ScrollBlockerDirective, SharedModule, FormsModule],
  templateUrl: "./general-modal.component.html",
  styleUrls: ["./general-modal.component.scss"],
})
export class GeneralModalComponent implements OnInit {
  @Output() acceptEmit: EventEmitter<any> = new EventEmitter();
  @Output() cancelEmit: EventEmitter<any> = new EventEmitter();
  @Input() config: number;
  @Input() data: any;

  public preventCloseModal: boolean = false;
  public showModal: boolean = false;
  public hiddenModal: boolean = false;
  public configGeneral = configGeneral;
  public loading: boolean = false;

  constructor(
    public _router: Router,
    public _route: ActivatedRoute,
    private _linksService: PromoListsService,
    private _trainService: TrainingService,
    private _affiliateService: AffiliatesService
  ) {}

  ngOnInit(): void {}

  cancelModal() {
    this.showModal = false;
    this.hiddenModal = true;
  }

  openModal() {
    this.showModal = true;
    this.hiddenModal = false;

    // [OFFERS DEPRECATED] offer selection removed from campaign creation
  }

  acceptModalEmit() {
    if (this.config == this.configGeneral.CREATE_CAMPAIGN) {
      this.acceptEmit.emit({ data: this.data });
      return;
    }

    if(this.config == this.configGeneral.DISABLED_RESOURCES){
      this.acceptEmit.emit({ data: this.data, isPublic: true });
      return;
    }

    this.acceptEmit.emit(this.data);
  }

  cancelModalEmit() {
    this.cancelModal();
    this.cancelEmit.emit();
  }

  contactSales() {
    this.cancelModal();
    window.open(
      "https://api.whatsapp.com/send/?phone=%2B13022615750&type=phone_number&app_absent=0&text=Servicio%20de%20ventas%20Edutin",
      "_blank"
    );
  }

  versionName: string;
  createVersion() {
    this.acceptEmit.emit(this.versionName);
    this.cancelModal();
  }

  deleteList(list: PromoList) {
    this.loading = true;
    this._linksService
      .deletePromoList(this._trainService.business.id, list.id)
      .subscribe((data) => {
        if (data.valid) {
          this._linksService.promoListsInfo =
            this._linksService.promoListsInfo.filter(
              (item) => list.id != item.id
            );

          this._router.navigate(["/affiliate/main"]);
          this.loading = false;
          this.cancelModal();
        }
      });
  }

  // [OFFERS DEPRECATED] offers, selectedOffer, loadingOffers, getOffers(), setUpOffers() removed
}
